import React, { memo } from 'react'
import cn, { Argument as ClassName } from 'classnames'
import styled from 'styled-components'

import { PartnersListWidget } from '../../../lib/partners-list-widget'

const SContainer = styled.div`
    width: 96%;
    max-width: 1170px;
    margin: 0 auto;
    padding: 0 15px;
`

export type PartnersPageProps = {
    className?: ClassName
    style?: React.CSSProperties
}

export const PartnersPage = memo(function PartnersPage({ className, style }: PartnersPageProps): React.ReactElement {
    return (
        <SContainer className={cn(className)} style={style}>
            <PartnersListWidget />
        </SContainer>
    )
})
